<template>
  <el-dialog class="opus-status-dialog" :visible.sync="data.visible" :title="title"
             width="620px"
             center>
    <div class="pv-content">
      <el-form label-width="220px">
        <el-form-item label="用户名" class="divider">
          {{ data.nickname }}
        </el-form-item>
        <div v-for="(item,i) in data.row" :key="i">
          <el-form-item label="登录类型">
            {{ item.auth_name }}
          </el-form-item>
          <el-form-item label="登录账号">
            {{ item.auth_open_id }}
          </el-form-item>
          <el-form-item label="登录密码" class="divider">
            {{ item.auth_access_token }}
          </el-form-item>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: '',
    data: {
      visible: false,
      nickname: '',
      row: []
    }
  },
  methods: {}
}
</script>

<style>
.opus-status-dialog .el-dialog {
  background: #e5e9f2;
}

.opus-status-dialog .el-dialog__header {
  padding: 0 20px 0px 20px;
  height: 50px;
  background-color: #fff;
}

.opus-status-dialog .el-dialog__title {
  color: #0C0C0C;
  line-height: 50px;
}

.opus-status-dialog .el-dialog__body {
  padding: 0;
}

.opus-status-dialog .pv-content {
  padding-top: 5px;
  width: 620px;
  min-height: 400px;
  margin-left: auto;
  margin-right: auto;
}

.opus-status-dialog .pv-content .el-form-item {
  margin-bottom: 0px;
}
.opus-status-dialog .pv-content .el-form-item.divider{
  border-bottom: 1px solid #348fe2;
}

.opus-status-dialog .pv-content .el-form-item__label {
  color: #0C0C0C;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/UserPasswordDialog.vue